var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['btn', 'btn-' + _vm.color, _vm.btnBlock, _vm.disabled],attrs:{"type":_vm.type},on:{"click":function($event){return _vm.$emit('click', $event)}}},[(!_vm.loading)?_vm._t("default"):_vm._e(),_vm._v(" "),(_vm.loading)?_c('span',[_vm._v(_vm._s(_vm.loadingText))]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aeca2d84","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UIComponents/Buttons/FormButton.vue
// module id = null
// module chunks = 